import React from "react";
import styles from "./grid-list.module.css";
import { IPostInsight } from "../../../interfaces/insightPost";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";

type Props = {
  insightList: IPostInsight[];
  onEditInsight: (id: string) => void;
  onRemoveInsight: (id: string) => void;
};

const GridList = ({ insightList, onEditInsight, onRemoveInsight }: Props) => {
  return (
    <div className={styles.page}>
      <div className={styles.container_title_div}>
        <h1 className={styles.container_title}>Lista de Insights</h1>
      </div>
      <div className={styles.grid_list}>
        <div className={styles.list_cabecalho}>
          <span className={`${styles.list_cabecalho_title} ${styles.w50}`}>
            Título
          </span>
          <span className={`${styles.list_cabecalho_text} ${styles.w20}`}>
            Data da Postagem
          </span>
          <span className={`${styles.list_cabecalho_text} ${styles.w20}`}>
            Postado pelo Usuário
          </span>
          <span className={`${styles.w5}`}></span>
          <span className={`${styles.w5}`}></span>
        </div>
        <ul className={styles.list}>
          {insightList.map((insight: IPostInsight) => (
            <li key={insight._id} className={styles.list_item}>
              <span className={`${styles.list_item_title} ${styles.w50}`}>
                {insight.title}
              </span>
              <span className={`${styles.list_item_text} ${styles.w20}`}>
                {insight.date}
              </span>
              <span className={`${styles.list_item_text} ${styles.w20}`}>
                {insight.username}
              </span>
              <div className={`${styles.action_btn_div} ${styles.w5}`}>
                <button
                  className={styles.action_btn}
                  onClick={() => {
                    if (insight._id) onEditInsight(insight._id);
                  }}
                >
                  <FontAwesomeIcon icon={faEdit} size="sm" />
                </button>
              </div>
              <div className={`${styles.action_btn_div} ${styles.w5}`}>
                <button
                  className={styles.action_btn}
                  onClick={() => {
                    if (insight._id) onRemoveInsight(insight._id);
                  }}
                >
                  <FontAwesomeIcon icon={faTrash} size="sm" />
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default GridList;
